import React, { useContext, useEffect } from "react";
import { AppContext } from "../../store/AppContext";
import Coupons from "./components/Coupons/Coupons";
import AddNewCoupon from "./components/AddNewCoupon/AddNewCoupon";

const CouponsTab = () => {
  const { couponTabInfo, setCouponTabInfo } = useContext(AppContext);

  useEffect(() => {
    setCouponTabInfo({
      addCoupon: false,
      trigger: false,
      selectedCoupon: null,
      page: 1,
      totalPages: 1,
    });
  }, []);

  return (
    <>
      {couponTabInfo?.addCoupon || couponTabInfo?.selectedCoupon ? (
        <AddNewCoupon />
      ) : (
        <Coupons />
      )}
    </>
  );
};

export default CouponsTab;
